// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import { actions } from 'Participant/Wishlist'
import WishlistHeart from './WishlistHeart'

const mapStateToProps = ({ wishlist }, ownProps) => {
  var wishlistItem = wishlist && wishlist.groupedWishlistBySkuId && wishlist.groupedWishlistBySkuId[ownProps.skuId]
  return wishlistItem
    ? {
      loading: wishlistItem.loading,
      removed: wishlistItem.removed,
      error: wishlistItem.error
    }
    : {
      notAdded: true
    }
}

const mapDispatchToProps = dispatch => ({
  removeWishlist: skuId => dispatch(actions.removeWishlist(skuId)),
  addWishlist: skuId => dispatch(actions.addWishlist(skuId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WishlistHeart)



// WEBPACK FOOTER //
// ./src/features/WishlistHeart/WishlistHeartContainer.js